import Grid from '@material-ui/core/Grid';
import React, { useState } from 'react';

import Alert from '../../components/alerts';
import AuthLayout from '../../components/auth-layout';
import RegistrationComplete from '../../components/registration-complete';
import { useTranslation } from '../../hooks/useTranslation';
import { RegistrationPageProps } from './index';
import { useLocation } from '@reach/router';
import { useIsMobile } from '../../util/style-utils';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useStyles from '../../components/registration/registration.styles';
import TextLink from '../../components/text-link';
import theme from '../../themes/theme';

type LocationState = {
  groupName?: string;
  email?: string;
};

const Footer = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box css={{ marginTop: '8px' }}>
      <Typography
        className={classes.textPrimary}
        color={'textPrimary'}
        variant={'body1'}
      >
        {t('CALL_FOR_ASSISTANCE') + ' '}{' '}
        <TextLink
          external
          textColor={theme.palette.primary.main}
          to={`tel:${t('CALL_FOR_ASSISTANCE_NUMBER_REGISTRATION')}`}
        >
          {t('CALL_FOR_ASSISTANCE_NUMBER_REGISTRATION')}
        </TextLink>
      </Typography>
    </Box>
  );
};

const RegistrationCompletePage = (props: RegistrationPageProps) => {
  const { t } = useTranslation();
  const title = t('REGISTRATION_COMPLETE_HEADER');
  const isMobile = useIsMobile();
  const childProps = { ...props, isMobile };
  const [isAlertOpen, toggleAlertBox] = useState(true);

  const location = useLocation();
  const locationState = (location.state || {}) as LocationState;

  return (
    <>
      <Grid style={{ marginTop: '1em' }}>
        <Alert
          isOpen={isAlertOpen}
          severity={'success'}
          variant={'filled'}
          title={t('REGISTRATION_COMPLETE_SUBTITLE')}
          onClose={() => toggleAlertBox(!isAlertOpen)}
        />
      </Grid>
      <AuthLayout title={title} showLeft={false} footer={<Footer />}>
        <RegistrationComplete
          {...childProps}
          email={locationState.email}
          groupName={locationState.groupName}
        />
      </AuthLayout>
    </>
  );
};

export default RegistrationCompletePage;
